import { render, staticRenderFns } from "./ConfirmUpdateBulkModal.vue?vue&type=template&id=1218cc33"
import script from "./ConfirmUpdateBulkModal.vue?vue&type=script&lang=js"
export * from "./ConfirmUpdateBulkModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmUpdateBulkModal.vue?vue&type=style&index=0&id=1218cc33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports